/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20SecurityScheme } from '../../asyncapi/v2/models/Aai20SecurityScheme';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { DocumentType } from '../../core/models/DocumentType';
import { SecurityRequirement } from '../../core/models/common/SecurityRequirement';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { VisitorUtil } from '../../core/util/VisitorUtil';
import { TraverserDirection } from '../../core/visitors/TraverserDirection';
import { Oas20Document } from '../../openapi/v2/models/Oas20Document';
import { Oas20SecurityScheme } from '../../openapi/v2/models/Oas20SecurityScheme';
import { Oas30Document } from '../../openapi/v3/models/Oas30Document';
import { Oas30SecurityScheme } from '../../openapi/v3/models/Oas30SecurityScheme';
import { Oas20SecurityDefinitions } from '../../openapi/v2/models/Oas20SecurityDefinitions';
import { Oas30Components } from '../../openapi/v3/models/Oas30Components';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { AaiSecurityScheme } from '../../asyncapi/models/AaiSecurityScheme';

/**
 * A command used to rename a security scheme, along with all references to it.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class RenameSecuritySchemeCommand extends AbstractCommand {
    public _oldSchemeName : string;

    public _newSchemeName : string;

    public constructor(oldSchemeName? : any, newSchemeName? : any) {
        if(((typeof oldSchemeName === 'string') || oldSchemeName === null) && ((typeof newSchemeName === 'string') || newSchemeName === null)) {
            let __args = arguments;
            super();
            if(this._oldSchemeName===undefined) this._oldSchemeName = null;
            if(this._newSchemeName===undefined) this._newSchemeName = null;
            if(this._oldSchemeName===undefined) this._oldSchemeName = null;
            if(this._newSchemeName===undefined) this._newSchemeName = null;
            (() => {
                this._oldSchemeName = oldSchemeName;
                this._newSchemeName = newSchemeName;
            })();
        } else if(oldSchemeName === undefined && newSchemeName === undefined) {
            let __args = arguments;
            super();
            if(this._oldSchemeName===undefined) this._oldSchemeName = null;
            if(this._newSchemeName===undefined) this._newSchemeName = null;
            if(this._oldSchemeName===undefined) this._oldSchemeName = null;
            if(this._newSchemeName===undefined) this._newSchemeName = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[RenameSecuritySchemeCommand] Executing.");
        this._doSecuritySchemeRename(document, this._oldSchemeName, this._newSchemeName);
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[RenameSecuritySchemeCommand] Reverting.");
        this._doSecuritySchemeRename(document, this._newSchemeName, this._oldSchemeName);
    }

    /**
     * Does the work of renaming a path from one name to another.
     * @param {Document} document
     * @param {string} from
     * @param {string} to
     * @private
     * @private
     */
    /*private*/ _doSecuritySchemeRename(document : Document, from : string, to : string) {
        let scheme : SecurityScheme = null;
        if(document.getDocumentType() === DocumentType.openapi2) {
            let doc20 : Oas20Document = <Oas20Document>document;
            if(ModelUtils.isDefined(doc20.securityDefinitions)) {
                if(ModelUtils.isDefined(doc20.securityDefinitions.getSecurityScheme(to))) {
                    return;
                }
                scheme = doc20.securityDefinitions.removeSecurityScheme(from);
            }
        } else if(document.getDocumentType() === DocumentType.openapi3) {
            let doc30 : Oas30Document = <Oas30Document>document;
            if(ModelUtils.isDefined(doc30.components)) {
                if(!this.isNullOrUndefined(doc30.components.getSecurityScheme(to))) {
                    return;
                }
                scheme = doc30.components.removeSecurityScheme(from);
            }
        } else {
            let aai20Document : Aai20Document = <Aai20Document>document;
            if(ModelUtils.isDefined(aai20Document.components)) {
                if(!this.isNullOrUndefined(aai20Document.components.getSecurityScheme(to))) {
                    return;
                }
                scheme = aai20Document.components.removeSecurityScheme(from);
            }
        }
        if(this.isNullOrUndefined(scheme)) {
            return;
        }
        scheme.rename(to);
        if(document.getDocumentType() === DocumentType.openapi2) {
            let doc20 : Oas20Document = <Oas20Document>document;
            doc20.securityDefinitions.addSecurityScheme(to, <Oas20SecurityScheme>scheme);
        } else if(document.getDocumentType() === DocumentType.openapi3) {
            let doc30 : Oas30Document = <Oas30Document>document;
            doc30.components.addSecurityScheme(to, <Oas30SecurityScheme>scheme);
        } else {
            let aai20Document : Aai20Document = <Aai20Document>document;
            aai20Document.components.addSecurityScheme(to, <Aai20SecurityScheme>scheme);
        }
        VisitorUtil.visitTree(document, new RenameSecuritySchemeCommand.RenameSecuritySchemeCommand$0(this, from, to), TraverserDirection.down);
    }
}
RenameSecuritySchemeCommand["__class"] = "io.apicurio.datamodels.cmd.commands.RenameSecuritySchemeCommand";
RenameSecuritySchemeCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];



export namespace RenameSecuritySchemeCommand {

    export class RenameSecuritySchemeCommand$0 extends CombinedVisitorAdapter {
        public __parent: any;
        /**
         * 
         * @param {SecurityRequirement} node
         */
        public visitSecurityRequirement(node : SecurityRequirement) {
            let scopes : Array<string> = node.removeSecurityRequirementItem(this.from);
            if(ModelUtils.isDefined(scopes)) {
                node.addSecurityRequirementItem(this.to, scopes);
            }
        }

        constructor(__parent: any, private from: any, private to: any) {
            super();
            this.__parent = __parent;
        }
    }
    RenameSecuritySchemeCommand$0["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];


}



